import React from 'react'
import { useTranslation } from 'react-i18next'
import { Header } from 'semantic-ui-react'
import styled from 'styled-components'
import { CoolFarmCropResultsType } from '~/api/services/coolFarmCrop'
import SummaryCards from './SummaryCards'
import BarChart from './BarChart'
import EmissionBreakdown from './EmissionBreakdown'
import DetailedDataTable from './DetailedDataTable'

interface ResultsProps {
  results: CoolFarmCropResultsType | null
}

const ResultsContainer = styled.div`
  padding: 20px;
  margin: 0 auto;
`

const Results: React.FC<ResultsProps> = ({ results }) => {
  const { t } = useTranslation()

  if (!results) {
    return (
      <ResultsContainer>
        <Header as='h2' textAlign='center'>
          {t('No results available')}
        </Header>
      </ResultsContainer>
    )
  }

  return (
    <ResultsContainer>
      <SummaryCards results={results} />
      <BarChart results={results} />
      <EmissionBreakdown results={results} />
      <DetailedDataTable results={results} />
    </ResultsContainer>
  )
}

export default Results